var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRawpc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.1069+31.2486C15.1069+30.6463+16.0413+30.1581+17.194+30.1581C18.3466+30.1581+19.281+30.6463+19.281+31.2486C19.281+31.8509+18.3466+32.3391+17.194+32.3391C16.0413+32.3391+15.1069+31.8509+15.1069+31.2486Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6091+27.026C21.6091+26.4611+22.4856+26.0031+23.5667+26.0031C24.6478+26.0031+25.5242+26.4611+25.5242+27.026C25.5242+27.5909+24.6478+28.0488+23.5667+28.0488C22.4856+28.0488+21.6091+27.5909+21.6091+27.026Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2401+22.9744C30.2401+22.4112+31.1139+21.9546+32.1917+21.9546C33.2695+21.9546+34.1432+22.4112+34.1432+22.9744C34.1432+23.5375+33.2695+23.9941+32.1917+23.9941C31.1139+23.9941+30.2401+23.5375+30.2401+22.9744Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7426+36.5308C21.7426+35.9127+22.7016+35.4116+23.8845+35.4116C25.0674+35.4116+26.0264+35.9127+26.0264+36.5308C26.0264+37.1489+25.0674+37.65+23.8845+37.65C22.7016+37.65+21.7426+37.1489+21.7426+36.5308Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8251+31.3023C29.8251+30.7159+30.7348+30.2406+31.8571+30.2406C32.9793+30.2406+33.8891+30.7159+33.8891+31.3023C33.8891+31.8887+32.9793+32.3641+31.8571+32.3641C30.7348+32.3641+29.8251+31.8887+29.8251+31.3023Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8578+26.2536C37.8578+25.6786+38.7499+25.2124+39.8504+25.2124C40.9509+25.2124+41.843+25.6786+41.843+26.2536C41.843+26.8286+40.9509+27.2948+39.8504+27.2948C38.7499+27.2948+37.8578+26.8286+37.8578+26.2536Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3862+41.3093C29.3862+40.612+30.468+40.0467+31.8024+40.0467C33.1369+40.0467+34.2187+40.612+34.2187+41.3093C34.2187+42.0066+33.1369+42.5718+31.8024+42.5718C30.468+42.5718+29.3862+42.0066+29.3862+41.3093Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7832+36.3785C37.7832+35.7269+38.7941+35.1987+40.041+35.1987C41.288+35.1987+42.2988+35.7269+42.2988+36.3785C42.2988+37.03+41.288+37.5582+40.041+37.5582C38.7941+37.5582+37.7832+37.03+37.7832+36.3785Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3256+31.5276C45.3256+30.9423+46.2337+30.4678+47.3539+30.4678C48.474+30.4678+49.3821+30.9423+49.3821+31.5276C49.3821+32.1129+48.474+32.5874+47.3539+32.5874C46.2337+32.5874+45.3256+32.1129+45.3256+31.5276Z",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86259+2.41094L9.81304+2.34368L9.79677+61.4088L55.8441+61.365L55.7513+12.9487L57.743+13.4742L57.5137+63.0539L7.97045+63.0612",
    opacity: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9878+2.3491L7.88113+0.455633L45.5251+0.439428L57.7496+13.5483L43.976+13.33L43.976+1.71189L45.8571+1.90553L45.9175+11.6119L53.7547+11.7896L44.8344+2.25794",
    opacity: 1,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawpc);
export default __webpack_public_path__ + "static/media/rawpc.610eddf451cc3de9a981553640fdc270.svg";
export { ForwardRef as ReactComponent };